"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EPaymentMethodTrads = void 0;
exports.EPaymentMethodTrads = {
    cheque: "Chèque",
    credit: "Crédit",
    credit_consortium: "Crédit Consortium",
    prelevement: "Prélèvement",
    virement: "Virement",
};
